import { cart, pubsub } from '@services';
import { parseHTML } from '@utils';

class CartItemCount extends HTMLElement {
  #unsubscribers = [];

  static {
    cart.sections.push('fetch-cart-item-count');
  }

  connectedCallback() {
    this.#unsubscribers.push(
      ...['cart:add', 'cart:update', 'cart:change'].map((event) =>
        pubsub.subscribe(event, ({ sections }) => this.#renderSection(sections))
      )
    );
  }

  disconnectedCallback() {
    this.#unsubscribers.forEach((unsubscribe) => unsubscribe());
  }

  /**
   * Add cart count
   */
  #renderSection(sections) {
    const html = parseHTML(sections['fetch-cart-item-count']);
    const target = html.querySelector('cart-item-count');
    this.replaceWith(target);
  }
}

customElements.define('cart-item-count', CartItemCount);
